import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Master from '../container/Master';
import { getPrefByName } from '../selectors/userPreferences';

export const TeamsRoute = ({
    isAuthenticated,
    prefLoaded,
    teamsEnabled,
    component: Component,
    routeName = false,
    hasTeam,
    ...rest
}) => (
    <Route {...rest} render={(props) => {
        if (!isAuthenticated) {
            return <Redirect to={{ pathname: "/", search: props.location?.search || "" }} />;
        }
        if (!prefLoaded) {
            return <Spinner animation="border" variant="primary" size="sm" />;
        }
        if (!teamsEnabled && !hasTeam) {
            return <Redirect to="/all" />;
        }
        return <Master component={Component} routeName={routeName} location={props.location} {...rest} {...props} />;
    }} />
);

const mapStateToProps = (state) => {
    const pref = state.user.pref;
    const prefLoaded = !!pref && pref.length > 0;
    return {
        isAuthenticated: !!state.auth.isLoggedIn,
        prefLoaded,
        teamsEnabled: prefLoaded ? getPrefByName("FS_ADMIN", pref, "value") == 1 : false,
        hasTeam: prefLoaded ? [1,2].includes(getPrefByName("FS_TEAMS", pref, "value")) : false,
    };
};

export default connect(mapStateToProps)(TeamsRoute);
